module.exports = __webpack_public_path__ + "static/media/church.74efabb7.svg";